import type { QueryClient } from '@tanstack/react-query';

export const getCachedListResultByIds = <T extends { id: string }>(
  queryClient: QueryClient,
  idsStr: string,
  entity: string,
) => {
  const idsSet = new Set(idsStr?.split(','));

  if (!idsSet.size) {
    return undefined;
  }

  const queryCache = queryClient.getQueryCache();
  const allQueries = queryCache.findAll({
    predicate: (query) =>
      Array.isArray(query.queryKey) &&
      query.queryKey[0].entity === entity &&
      query.queryKey[0].scope === 'list',
  });

  const resultMap = new Map<string, T>();

  for (const query of allQueries) {
    const data = query.state.data as { data?: T[] } | undefined;

    if (data?.data?.length) {
      data.data.forEach((item) => {
        if (item.id && idsSet.has(item.id) && !resultMap.has(item.id)) {
          resultMap.set(item.id, item);
        }
      });
    }
  }

  if (resultMap.size === idsSet.size) {
    const data = Array.from(resultMap.values());

    // it's not important how many pages are there because this is just a cache fetch for entity list by ids
    return {
      data,
      page: 1,
      total: data.length,
      totalPages: 1,
    };
  }
};
